export function TopCTA({ applyURL }: any) {
  return (
    <div className="text-center">
      <h1 className="text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl">
        <span className="inline">Clerk for</span>{' '}
        <span className="inline text-clerk-blue">Startups</span>
      </h1>
      <p className="max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        Launch your application with beautiful user management features.
        <br />
      </p>
      <p className="max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        Save <strong>time</strong> and <strong>money</strong> with up to 6
        months free.
      </p>
      <div className="max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8">
        <div className="rounded-md">
          <a
            href={applyURL}
            target="_blank"
            rel="noopener"
            className="flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn"
          >
            Apply now
          </a>
        </div>
      </div>
    </div>
  );
}
